import { useQuery } from 'libs/query'
import axios from 'libs/fetch'
import { SettingsRes } from 'features/dashboard'
import { queryKeys } from 'config/queryKeys'
import { apiRoutes } from 'config/apiRoutes'
import { useTranslation } from 'libs/i18n'
import { useContext, useEffect } from 'react'
import { StoreSettingsContext } from 'store'

export const useFetchStoreData = () => {
	const { i18n } = useTranslation()
	const storeCtx = useContext(StoreSettingsContext)

	const { data, isLoading, refetch, isFetching, isSuccess } = useQuery<SettingsRes>({
		queryKey: queryKeys.storeData.all,
		queryFn: () => axios.get(apiRoutes.store),
		refetchOnWindowFocus: false
	})

	useEffect(() => {
		if (data) {
			storeCtx?.setStoreSettings(data?.data)
			storeCtx?.setPrimaryColor(data?.data.primary_color)
			i18n.changeLanguage(data?.data?.default_language ? data.data.default_language : 'en')
		}
	}, [data, isSuccess])

	return {
		data,
		isLoading,
		refetch,
		isFetching
	}
}
